module.exports = __webpack_public_path__ + "img/1485689040.b930aabf.jpg";